import { Breadcrumbs } from '@mui/material';
import { useSearchParams } from 'react-router';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRightTwoTone';
import DispatchBackButton from './Actions/DispatchBackButton';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { defaultFilterModel } from './types';

import styles from './DataGrid.Dispatch.module.css';
import { emptyRowSet } from '../types';

export default function DispatchBreadcrumbs() {
	const [searchParams, setSearchParams] = useSearchParams();
	const gridContext = useGridApiContext();
	const job = searchParams.get('job');
	const csn = searchParams.get('csn');

	return (
		<div className={styles['dispatch-breadcrumbs']}>
			<DispatchBackButton />

			<Breadcrumbs
				aria-label='breadcrumb'
				separator={<KeyboardDoubleArrowRightIcon fontSize='small' />}
			>
				{job && (
					<span
						onClick={() => {
							gridContext.current.setFilterModel(defaultFilterModel);
							gridContext.current.setRowSelectionModel(emptyRowSet);
							setSearchParams({
								job: job
							});
						}}
						className={styles['breadcrumb-link']}
					>
						{job}
					</span>
				)}
				{job && csn && (
					<span
						onClick={() => {
							gridContext.current.setFilterModel(defaultFilterModel);
							gridContext.current.setRowSelectionModel(emptyRowSet);
							setSearchParams({
								job: job,
								csn: csn
							});
						}}
						className={styles['breadcrumb-link']}
					>
						{csn}
					</span>
				)}
			</Breadcrumbs>
		</div>
	);
}
